<template lang="pug">
div.personalCenter
  .left
    .header
      .imgbox
        .mask
          Upload(action="./api/user/updateHeadImag",
            name="image",accept=".jpg,.png",
            :before-upload="bUpload",:on-success="aUpload",
            :headers ="{ token: token }",
            :data="{code: form.code}",
            :show-upload-list="false",
            :max-size="200",
            :on-exceeded-size="handleMaxSize")
            Icon(type="md-add")
        img(:src="form.headImagePath")
  .right
    i-form(:model="form",:rules="formRules",:label-width="80")
      Form-item(label="账号：")
        span {{form.code}}
      Row
        i-col(span="10",col-10)
          Form-item(label="姓名：",prop="name")
            i-input(v-model.sync="form.name" ,:maxlength="20")
        i-col(span="10",col-10)
          Form-item(label="班级：")
            span {{form.className}}
      Form-item(label="个人宣言：",prop="personalSignature")
        i-input(type="textarea",v-model.sync="form.personalSignature" :maxlength="200")
      Form-item.save
        i-button(type="primary",@click.native="saveBaseData") 保存
    i-form(:model="form1",:rules="formRules1",:label-width="80",ref="form1")
      Form-item.oldPassword(label="原密码：",prop="oldPassword")
        i-input(type="password",v-model.sync="form1.oldPassword")
      Row
        i-col(span="10",col-10)
          Form-item(label="新密码：",prop="newPassword")
            i-input(type="password",v-model.sync="form1.newPassword")
        i-col(span="10",col-10)
          Form-item(label="确认密码：",prop="rePassword")
            i-input(type="password",v-model.sync="form1.rePassword")
      Form-item
        i-button(type="primary",@click.native="savePassWord('form1')") 保存密码
</template>

<script>
import MyBus from "@/utils/main";
export default {
  data() {
    const validatePassCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入新密码"));
      } else if (value !== this.form1.newPassword) {
        callback(new Error("两次输入的新密码不同"));
      } else {
        callback();
      }
    };
    return {
      form: {
        code: "",
        name: "",
        className: "",
        personalSignature: "",
        headImagePath: ""
      },
      token: sessionStorage.getItem("tokenTest"),
      formRules: {
        name: [
          { required: true, message: "名字不可以为空", trigger: "change" },
          {
            max: 20,
            min: 2,
            message: "姓名只能是2-20位",
            trigger: "change"
          }
        ],
        personalSignature: [
          { max: 200, message: "不可以超过200字", trigger: "change" }
        ]
      },
      form1: {
        oldPassword: "",
        newPassword: "",
        rePassword: ""
      },
      formRules1: {
        oldPassword: [
          {
            pattern: /^[a-zA-Z0-9]{1,16}$/,
            message: "密码只能为字母数字,长度不能超过16位",
            trigger: "change"
          }
        ],
        newPassword: [
          {
            pattern: /^[a-zA-Z0-9]{1,16}$/,
            message: "密码只能为字母数字,长度不能超过16位",
            trigger: "change"
          }
        ],
        rePassword: [{ validator: validatePassCheck, trigger: "change" }]
      }
    };
  },
  methods: {
    saveBaseData() {
      this.$http
        .changeUserSignature({
          code: this.form.code,
          name: this.form.name,
          personalSignature: this.form.personalSignature
        })
        .then(res => {
          if (res.data.success) {
            this.$Message.success("保存成功");
          }
        });
    },
    bUpload(file) {
      const index = file.name.indexOf(".jpg");
      if (index < 0) {
        const index1 = file.name.indexOf(".png");
        if (index1 < 0) {
          this.$Message.error("图片格式错误");
          return false;
        }
      }
    },
    aUpload(file) {
      this.form.headImagePath = file.data.url;
      MyBus.$emit("getByCode");
      this.$Message.success("头像上传成功");
    },
    handleMaxSize() {
      this.$Message.error("图片大小不可以超过200KB");
    },
    getData() {
      this.$http
        .getByCode({
          code: this.form.code
        })
        .then(res => {
          if (res.data.success) {
            this.form.code = res.data.data.code;
            this.form.headImagePath = res.data.data.headImagePath;
            this.form.name = res.data.data.name;
            this.form.className = res.data.data.className;
            this.form.personalSignature = res.data.data.personalSignature;
          }
        });
    },
    savePassWord(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$http
            .changePassword({
              code: this.form.code,
              newPassword: this.form1.newPassword,
              oldPassword: this.form1.oldPassword
            })
            .then(res => {
              if (res.data.success) {
                this.$Message.success("保存成功!请牢记新密码");
              } else {
                this.$Message.error("保存失败!");
              }
            });
        } else {
          this.$Message.error("保存失败!");
        }
      });
    }
  },
  created() {
    const token = JSON.parse(window.sessionStorage.getItem("token"));
    this.form.code = token.code;
    this.getData();
  }
};
</script>

<style lang="stylus">
.ivu-form
  .ivu-form-item
    .ivu-form-item-content
      text-align left
      .ivu-input-wrapper
        width 70%
  .oldPassword
    .ivu-form-item-content
      .ivu-input-wrapper
        width 25%
  .save
    margin-bottom 50px
.personalCenter
  border-radius 5px
  height calc(100vh - 120px)
  display flex
  div
    flex 1
  .left
    flex 0 0 300px
    .header
      width 100%
      height 150px
      margin-bottom 20px
      .imgbox
        height 150px
        width 120px
        margin 0 auto
        position relative
        img
          width 100%
          height 100%
        .mask
          position absolute
          width 100%
          height 100%
          background-color rgba(0, 0, 0, 0.38)
          z-index 5
          display none
        &:hover
          .mask
            display block
          .ivu-icon-md-add
            position absolute
            left 50%
            top 50%
            margin-left -15px
            margin-top -15px
            font-size 30px
            color #fff
</style>
